import React, { FC, useEffect, useState } from 'react';

import { styled } from '../theme';

const Container = styled('div')<{
    isVisible: boolean;
    transitionDuration?: number;
    style?: React.CSSProperties;
}>(({ theme, isVisible, transitionDuration = 500, style = {} }) => ({
    transition: 'opacity 0.5s ease-in-out',
    opacity: isVisible ? 1 : 0,
    transitionDuration: `${transitionDuration}ms`,
    ...style,
}));

type Props = {
    in: boolean;
    timeout?: number;
    style?: React.CSSProperties;
};

export const Fade: FC<Props> = ({ in: inProp, children, timeout = 150, style }) => {
    const [isVisible, setVisibility] = useState(false);

    useEffect(() => {
        if (inProp) {
            setVisibility(true);
        } else {
            const timer = setTimeout(() => setVisibility(false), timeout);
            return () => clearTimeout(timer);
        }
    }, [inProp, timeout]);

    return (
        <Container isVisible={isVisible} transitionDuration={timeout} style={style}>
            {children}
        </Container>
    );
};

export default Fade;
